
import Cell from 'vux/src/components/cell/index.vue'

import { InsurStore } from '../../store'
import  Editor  from '@/views/stencil/components/editor'
export default {
name:'monthly',
data() {
return {
show: false
}
},
components: {
Cell,
Editor,
},
props: {
src: {
type: String,
default: ''
},
},
computed: {
insurance() {
return InsurStore.insurance
},
},
methods: {
details() {
this.STATISTICS_CONFIG.insur_proinfo_paymonthinfo_click()
this.show = true;
},
},
}

